module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/pppmaddog006#maintoc"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('em', {
    staticClass: "calibre5"
  }, [_vm._v("For Barbara,")]), _c('br', {
    staticClass: "calibre1"
  }), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("and for the fearsome Partridge Quails of ’62")]), _c('br', {
    staticClass: "calibre1"
  }), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("when we were young and the earth was verifiably flat")]), _c('br', {
    staticClass: "calibre1"
  }), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("and all the universe orbited around Kansas.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d44a5f96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-maddog004.vue
// module id = 66
// module chunks = 0